export default "__VITE_ASSET__60bbdaad__"